export enum Type {
  Feature = 'Feature',
  FeatureCollection = 'FeatureCollection',
  Geometry = 'Geometry',
  GeometryCollection = 'GeometryCollection',
  Point = 'Point'
}

export interface GeoJsonObject {
  coordinates: number[];
  features?: GeoJsonObject[];
  fileName?: string;
  geometry?: GeoJsonObject;
  geometries?: GeoJsonObject[];
  properties?: {
    title?: string;
    descrition?: string;
    color?: string;
    icon?: string;
    id?: number;
    url?: string;
    tags?: string[];
    Province?: string;
    District?: string;
    Ward?: string;
    ConstName1?: string;
    ADM1_NA?: string;
    ADM2_NA?: string;
    ADM3_PCODE?: string;
    style?: any;
    name: string;
    count?: number;
    region?:string;
    type?:string;
  };
  total?: number;
  type: Type;
}
